module.exports = __webpack_public_path__ + "img/icon_stage_outlined.0ea7ccef.svg";